exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n    min-width: 33%;\n    margin: 10px;\n}\n\n.provider-selection{\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.provider-selection input{\n    width: 2%;\n    margin: 0.5%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = 1067
// module chunks = 1